/**
 * Ziyaret Takip ikonları — repo konvansiyonu gereği inline SVG (projede ikon fontu YOK,
 * bkz. components/c360/icons.jsx). Hepsi 24 birim viewBox, currentColor ile boyanır.
 */

function Svg({ size = 16, children, fill = 'none' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ display: 'block' }}>
      {children}
    </svg>
  );
}

export const IcDashboard = (p) => (
  <Svg {...p}><rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" /></Svg>
);

export const IcList = (p) => (
  <Svg {...p}><path d="M9 6h11M9 12h11M9 18h11" /><path d="m4 6 1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2" /></Svg>
);

export const IcTimeline = (p) => (
  <Svg {...p}><circle cx="6" cy="6" r="2" /><circle cx="6" cy="18" r="2" />
    <path d="M6 8v8M11 6h9M11 18h9M11 12h6" /></Svg>
);

export const IcReport = (p) => (
  <Svg {...p}><path d="M14 3v5h5" /><path d="M19 8v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7z" />
    <path d="M9 13h6M9 17h4" /></Svg>
);

export const IcRefresh = (p) => (
  <Svg {...p}><path d="M20 11A8 8 0 0 0 6.3 6.3L4 8.5" /><path d="M4 4v4.5h4.5" />
    <path d="M4 13a8 8 0 0 0 13.7 4.7L20 15.5" /><path d="M20 20v-4.5h-4.5" /></Svg>
);

export const IcExcel = (p) => (
  <Svg {...p}><path d="M14 3v5h5" /><path d="M19 8v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7z" />
    <path d="m9 12 5 6M14 12l-5 6" /></Svg>
);

export const IcPrint = (p) => (
  <Svg {...p}><path d="M7 8V3h10v5" /><path d="M7 18H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" />
    <rect x="7" y="14" width="10" height="7" rx="1" /></Svg>
);

export const IcAlert = (p) => (
  <Svg {...p}><path d="M12 9v4M12 17h.01" />
    <path d="M10.3 3.9 2.4 17a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /></Svg>
);

export const IcChevron = (p) => (<Svg {...p}><path d="m9 6 6 6-6 6" /></Svg>);
export const IcClose = (p) => (<Svg {...p}><path d="M18 6 6 18M6 6l12 12" /></Svg>);
export const IcFoldUp = (p) => (<Svg {...p}><path d="M4 12h16" /><path d="m8 8 4-4 4 4" /><path d="m8 20 4-4 4 4" /></Svg>);
export const IcFoldDown = (p) => (<Svg {...p}><path d="M4 12h16" /><path d="m8 4 4 4 4-4" /><path d="m8 16 4 4 4-4" /></Svg>);

export const IcPin = (p) => (
  <Svg {...p}><circle cx="12" cy="10" r="3" /><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" /></Svg>
);

export const IcLogin = (p) => (<Svg {...p}><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><path d="m10 17 5-5-5-5M15 12H3" /></Svg>);
export const IcLogout = (p) => (<Svg {...p}><path d="M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4" /><path d="m16 17 5-5-5-5M21 12H9" /></Svg>);
export const IcStore = (p) => (<Svg {...p}><path d="M3 9 4.5 4h15L21 9" /><path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M9 21v-6h6v6" /></Svg>);
export const IcClock = (p) => (<Svg {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></Svg>);
export const IcTrash = (p) => (<Svg {...p}><path d="M4 7h16M10 11v6M14 11v6" /><path d="M5 7l1 13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-13M9 7V4h6v3" /></Svg>);
export const IcUnlock = (p) => (<Svg {...p}><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 7.5-2" /></Svg>);
export const IcCalc = (p) => (<Svg {...p}><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 7h8M8 12h.01M12 12h.01M16 12h.01M8 16h.01M12 16h.01M16 16h.01" /></Svg>);
